export default __webpack_public_path__ + "static/media/6.29b324a1.jpg";